import { Injectable } from '@angular/core';

@Injectable()
export class DividerConfigService {
    public readonly icon = '';
    public readonly description = '';
    public readonly title = '';
}
